// extracted by mini-css-extract-plugin
module.exports = {"NavigationBarTitle":"AppNavTitle_NavigationBarTitle__2xSsY"};